export const authRoutes = {
  login: '/dang-nhap',
  forgotPassword: '/quen-mat-khau',
  resetPassword: '/dat-lai-mat-khau'
};
